// deep-signal/nav-target.ts
//
// The navigate payload for this page.
//
// The app has no router: App.tsx's handleNavigate(page, payload) carries ONE
// optional string per destination, and for "deep-signal" that string is the
// tab to open (`setDeepSignalInitialTab`). The Brand Monitoring insight rail
// needs to send a tab AND an attribute to preselect, so both travel on that one
// channel as "tab" or "tab:attribute".
//
// Build and parse go through here rather than being spelled out at each end,
// so the two sides cannot drift apart.

export function deepSignalTarget(tab: string, attribute?: string | null): string {
  return attribute ? `${tab}:${attribute}` : tab;
}

export function parseDeepSignalTarget(raw?: string): { tab?: string; attribute?: string } {
  if (!raw) return {};
  const i = raw.indexOf(":");
  // No separator: a plain tab id, which is what every existing caller sends
  // (e.g. the Blueprint hand-off card passes "blueprint").
  if (i < 0) return { tab: raw };
  return { tab: raw.slice(0, i), attribute: raw.slice(i + 1) || undefined };
}
